<template>
  <div class="custom-select" :tabindex="tabindex" @blur="open = false">
    <!-- <div class="selected"> -->
    <input
      name="label"
      type="text"
      @click="open = !open"
      @blur="blurInput"
      autocomplete="off"
      id="location"
      @input="search"
      :placeholder="label"
      :class="[error && 'error-border']"
      v-model="searchQuery"
    />
  </div>
  <div class="custom-select" :tabindex="tabindex" @blur="open = false">
    <div v-if="!select_obj" class="items shadow" :class="{ selectHide: !open }">
      <div
        v-for="(option, i) of data.slice(1, data.length)"
        :key="i"
        @click="
          selected = option;
          searchQuery = option;
          open = false;
          $emit('input', option);
        "
      >
        {{ option }}
      </div>
    </div>
    <div v-else class="items shadow" :class="{ selectHide: !open }">
      <div
        style="display: flex; align-items: center"
        v-for="(option, i) of data.slice(0, data.length)"
        :key="i"
        @click="
          selected_object = option;
          searchQuery = option[obj_select_key];
          open = false;
          $emit('input', option);
        "
      >
        {{ option[obj_select_key] }}
        <span :style="`font-size: 1.8em; margin-left: auto;`">
          <p v-if="option.is_favorite">
            <font-awesome-icon
              @click="removeFavoriteAddress(i, option.id)"
              style="color: #ffd700"
              icon="fas fa-star"
            />
          </p>
          <p v-else>
            <font-awesome-icon
              @click="setFavoriteAddress(i, option.id)"
              style="color: #e3dada"
              icon="fas fa-star"
            />
          </p>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      required: false,
    },
    select_obj: {
      type: Boolean,
      default: false,
    },
    obj_select_key: {
      type: String,
      default: "title",
    },
    label: {
      type: String,
      default: "Select option",
    },
    show_label_flag: {
      type: Boolean,
      default: true,
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      selected: this.default
        ? this.default
        : this.options && this.options.length > 0
        ? this.options[0]
        : null,
      open: false,
      data: [],
      selected_object: {},
    };
  },
  watch: {
    show_label_flag: function () {
      this.show_label = !this.show_label;
      if (this.show_label) {
        this.searchQuery = "";
      }
    },
    options: function () {
      this.data = [];
      this.data = this.options;
      this.data.sort((x, y) => y.is_favorite - x.is_favorite);
    },
    value: function (newVal) {
      if (!newVal) {
        this.selected = this.options[0];
        this.searchQuery = "";
        this.selected = this.default
          ? this.default
          : this.options && this.options.length > 0
          ? this.options[0]
          : null;
        this.$emit(
          "input",
          this.selected == this.options[0] ? null : this.selected
        );
      }
    },
  },
  methods: {
    removeFavoriteAddress(index, location_cluster_id) {
      axios
        .delete(
          `${this.$store.state.rootAPI}favorite_cluster/${location_cluster_id}`,
          {}
        )
        .then((res) => {
          (this.data[index].is_favorite = false),
            this.data.sort((x, y) => y.is_favorite - x.is_favorite);
          this.$notify({
            title: "Favorite Deleted",
            text: "Favorite Address was Deleted Successfully",
            type: "success",
          });
        })
        .catch((error) => {
          this.$notify({
            title: "Error",
            text: error.response.data.message,
            type: "error",
          });
        });
    },
    setFavoriteAddress(index, location_cluster_id) {
      axios
        .post(`${this.$store.state.rootAPI}favorite_cluster`, {
          location_cluster_id: location_cluster_id,
        })
        .then((res) => {
          this.data[index].is_favorite = true;
          this.data.sort((x, y) => y.is_favorite - x.is_favorite);
          this.$notify({
            title: "Favorite Added",
            text: "Favorite Address was Added Successfully",
            type: "success",
          });
        })
        .catch((error) => {
          this.$notify({
            title: "Error",
            text: error.response.data.message,
            type: "error",
          });
        });
    },
    async blurInput() {
      await new Promise((resolve) => setTimeout(resolve, 330));
      this.open = false;
    },
    search() {
      this.open = true;
      let arr = [];
      if (this.searchQuery) {
        this.data = this.options;
        this.data.forEach((value, index) => {
          if (
            value.title
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
              .includes(this.searchQuery.toLowerCase())
          )
            arr.push(value);
        });
        this.data = arr;
        this.data.sort((x, y) => y.is_favorite - x.is_favorite);
      } else {
        this.data = this.options;
        this.data.sort((x, y) => y.is_favorite - x.is_favorite);
      }
    },
  },

  computed: {
    filteredItems() {
      return this.data.filter((item) => {
        return item.title.indexOf(this.searchQuery.toLowerCase()) > -1;
      });
    },
  },
  mounted() {
    this.selected = this.options[0];
    this.show_label = this.show_label_flag;
    this.$emit(
      "input",
      this.selected == this.options[0] ? null : this.selected
    );
  },

  created() {
    this.data = this.options;
    this.data.sort((x, y) => y.is_favorite - x.is_favorite);
  },
};
</script>

<style scoped>
input {
  max-width: none !important;
}
.custom-select {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  float: left;
}

.custom-select .selected {
  background-color: #f7f8fa;
  width: 100%;
  border-radius: 10px;
  color: #788e98;
  border: 1px solid #c1c5d8;
  cursor: pointer;
  user-select: none;
  padding: 19px 15px;
  float: left;
}

.custom-select .selected span {
  width: max-content;
  float: left;
  font-size: 14px;
}

.custom-select .selected:after {
  position: absolute;
  content: "";
  top: 26px;
  right: 15px;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-color: #c1c5d8 transparent transparent transparent;
}

.custom-select .items {
  color: #fff;
  border-radius: 10px;
  overflow: auto;
  position: absolute;
  background-color: #ffffff;
  left: 0;
  right: 0;
  top: calc(100% + 8px);
  padding: 10px;
  z-index: 1;
  max-height: 15pc;
}
.custom-select .items::-webkit-scrollbar {
  width: 0.2em;
}
/* Track */
.custom-select .items::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.custom-select .items::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
.custom-select .items::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.custom-select .items div {
  color: #fff;
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
  padding: 8px 18px;
  color: #2f434c;
  font-size: 16px;
}

.custom-select .items div:not(:last-child) {
  border-bottom: 1px solid #e0e0df;
}

.custom-select .items div:last-child {
  border-radius: 0 0 8px 8px;
}

.custom-select .items div:first-child {
  border-radius: 8px 8px 0 0;
}

.custom-select .items div:hover {
  background-color: #f7f8fa;
}

.selectHide {
  display: none;
}
</style>
